import LoginModal from "../modals/LoginModal";
import axios from "axios";

let loginModal = new LoginModal()

$(document).on('click', '[href="#login"]', event => {
    event.preventDefault()
    run()
})

function run() {
    loginModal
        .run(done => {
            axios.post('/api/auth/sign-in', new FormData(loginModal.formElement))
                .then(result => {
                    let response = result.data
                    if (response.success) {
                        done()
                        window.location.reload()
                    }
                })
                .catch(error => {
                    let message = '', errors = error.response?.data?.errors
                    for (let key in errors) {
                        if (errors.hasOwnProperty(key)) {
                            message += errors[key].map(error => `<p>${error}</p>`).join('')
                        }
                    }
                    message && loginModal.notify.error(message)
                })
        })
}
